<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Acc from './acc'

export default {
  page: {
    title: 'ACC Monitoring',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader, Acc },
  data () {
    return {
      title: 'ACC',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          // Plain text: b-breadcrumb renders an item without href as href="#".
          text: 'Monitoring',
          active: true
        },
        {
          text: 'ACC',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <Acc :base-path="'/monitoring/acc'" />
  </Layout>
</template>
